module.exports = __webpack_public_path__ + "assets/img/start.png?582817dd5e6e011424933d868f13d937";